module.exports = __webpack_public_path__ + "static/media/pc_logo.296af717.png";